<template>
	<div class="header">
		<div class="sideLeft">
			<div class="burgerMenu" @click="toggleMenu" v-show="!isSchoolsList">
				<span></span>
				<span></span>
				<span></span>
			</div>
			<a href="/"><img src="../../assets/logov2-header.svg" /></a>
		</div>
		<div class="sideRight" v-if="showSchoolChange">
			<div class="switchCollege" @click="showModal">
				<span>{{school.name}}</span>
				<img src="../../assets/switch.svg"/>
			</div>
		  <b-modal size="lg asc" ref="myModalRef" lg hide-footer title="Seleccione un colegio">
		    <school-selecter @closeModal="hideModal"/>
		  </b-modal>
		</div>
		<div class="sideRight" v-else>
			<div class="switchCollege" @click="logout">
				<span>Cerrar sesión</span>
			</div>
		</div>
	</div>
</template>

<script>
import Auth from '@/services/Auth';
export default {
	computed: {
		school () {
			return this.$store.state.persistent.school;
		},
		showSchoolChange () {
			if (this.isSchoolsList) return false;
			if (!this.$store.state.persistent.schools) return false;
			return this.$store.state.persistent.schools.length > 1 && this.school;
		},
		currentRoute () {
			return this.$router.history.current.fullPath;
		},
		isSchoolsList () {
			return this.currentRoute == '/coaching/schools/list';
		}
	},
	methods: {
		toggleMenu () {
			this.$store.dispatch('toggleMenu');
		},
		showModal () {
			this.$refs.myModalRef.show();
		},
		hideModal () {
			this.$refs.myModalRef.hide();
		},
		logout () {
			Auth.logout();
		}
	}
};
</script>

<style lang="scss" scoped>

@import "../../scss/global.scss";
.header {
	background-color: $oxfordBlue;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	position: absolute;
	top: 0;
	left: 0;
	height: 6rem;
	width: 100%;
	z-index: 10;
}

.burgerMenu {
	border-radius: 0.2rem;
	display: none;
	flex-direction: column;
	justify-content: space-around;
	align-items: center;
	margin: 0 1.7rem 0 0;
	width: 3.6rem;
	height: 2.7rem;
	cursor: pointer;
	& > span {
		background-color: $liteGrey;
		border-radius: 0.1rem;
		height: 0.6rem;
		width: 100%;
	}
	&.disabled {
		cursor: not-allowed;
	}
	&:active {
			border: 0.1rem solid $dawnBlue;
		}
}

.switchCollege {
	display: flex;
	justify-content: space-around;
	align-items: center;
	opacity: 0.8;
	&:hover {
		opacity: 1;
		cursor: pointer;
	}
	& > span {
		margin-right: 0.7rem;
		font-size: $mediumSize;
		color: $blank;
	}
	& img {
		display: inline;
	}
}

@media only screen and (max-width: 1170px) {
	.burgerMenu {
		display: flex;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ui/TopBar.vue